import(/* webpackMode: "eager" */ "/app/src/layouts/simple/content.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/layouts/simple/layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/faqs/view/faqs-view.tsx");
